<template>
<div class="chapter">
<div class="inner_page">
<p class="toc2"><span><b>CONTENTS</b></span></p>
<p class="toc2"><a href="#/Book1/xhtml/cover">THE OTHER SIDE OF THE SUN</a></p>
<p class="toc2k"><a href="#/Book1/xhtml/part01">One</a></p>
<p class="toc2k"><a href="#/Book1/xhtml/chapter001">1</a></p>
<p class="toc2k"><a href="#/Book1/xhtml/part02">Two</a></p>
<p class="toc2k"><a href="#/Book1/xhtml/chapter002">1</a></p>
<p class="toc2k"><a href="#/Book1/xhtml/chapter003">2</a></p>
<p class="toc2k"><a href="#/Book1/xhtml/chapter004">3</a></p>
<p class="toc2k"><a href="#/Book1/xhtml/chapter005">4</a></p>
<p class="toc2k"><a href="#/Book1/xhtml/chapter006">5</a></p>
<p class="toc2k"><a href="#/Book1/xhtml/chapter007">6</a></p>
<p class="toc2k"><a href="#/Book1/xhtml/part03">Three</a></p>
<p class="toc2k"><a href="#/Book1/xhtml/chapter008">1</a></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter009" title="Link target outside of Sample">2</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter010" title="Link target outside of Sample">3</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter011" title="Link target outside of Sample">4</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter012" title="Link target outside of Sample">5</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter013" title="Link target outside of Sample">6</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter014" title="Link target outside of Sample">7</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter015" title="Link target outside of Sample">8</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter016" title="Link target outside of Sample">9</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter017" title="Link target outside of Sample">10</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter018" title="Link target outside of Sample">11</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter019" title="Link target outside of Sample">12</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/part04" title="Link target outside of Sample">Four</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter020" title="Link target outside of Sample">1</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter021" title="Link target outside of Sample">2</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter022" title="Link target outside of Sample">3</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter023" title="Link target outside of Sample">4</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter024" title="Link target outside of Sample">5</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter025" title="Link target outside of Sample">6</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/part05" title="Link target outside of Sample">Five</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter026" title="Link target outside of Sample">1</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter027" title="Link target outside of Sample">2</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter028" title="Link target outside of Sample">3</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter029" title="Link target outside of Sample">4</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter030" title="Link target outside of Sample">5</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter031" title="Link target outside of Sample">6</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter032" title="Link target outside of Sample">7</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter033" title="Link target outside of Sample">8</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter034" title="Link target outside of Sample">9</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/part06" title="Link target outside of Sample">Six</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter035" title="Link target outside of Sample">1</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter036" title="Link target outside of Sample">2</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter037" title="Link target outside of Sample">3</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter038" title="Link target outside of Sample">4</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter039" title="Link target outside of Sample">5</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter040" title="Link target outside of Sample">6</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/part07" title="Link target outside of Sample">Seven</span></p>
<p class="toc2k"><span href="#/Book1/xhtml/chapter041" title="Link target outside of Sample">1</span></p>
<p class="toc2"><span href="#/Book2/xhtml/cover" title="Link target outside of Sample">A LIVE COAL IN THE SEA</span></p>
<p class="toc2k"><span href="#/Book2/xhtml/chapter001" title="Link target outside of Sample">One</span></p>
<p class="toc2k"><span href="#/Book2/xhtml/chapter002" title="Link target outside of Sample">Two</span></p>
<p class="toc2k"><span href="#/Book2/xhtml/chapter003" title="Link target outside of Sample">Three</span></p>
<p class="toc2k"><span href="#/Book2/xhtml/chapter004" title="Link target outside of Sample">Four</span></p>
<p class="toc2k"><span href="#/Book2/xhtml/chapter005" title="Link target outside of Sample">Five</span></p>
<p class="toc2k"><span href="#/Book2/xhtml/chapter006" title="Link target outside of Sample">Six</span></p>
<p class="toc2k"><span href="#/Book2/xhtml/chapter007" title="Link target outside of Sample">Seven</span></p>
<p class="toc2k"><span href="#/Book2/xhtml/chapter008" title="Link target outside of Sample">Eight</span></p>
<p class="toc2k"><span href="#/Book2/xhtml/chapter009" title="Link target outside of Sample">Nine</span></p>
<p class="toc2k"><span href="#/Book2/xhtml/chapter010" title="Link target outside of Sample">Ten</span></p>
<p class="toc2k"><span href="#/Book2/xhtml/chapter011" title="Link target outside of Sample">Eleven</span></p>
<p class="toc2k"><span href="#/Book2/xhtml/chapter012" title="Link target outside of Sample">Twelve</span></p>
<p class="toc2"><span href="#/Book3/xhtml/cover" title="Link target outside of Sample">A WINTER’S LOVE</span></p>
<p class="toc2k"><span href="#/Book3/xhtml/chapter001" title="Link target outside of Sample">One</span></p>
<p class="toc2k"><span href="#/Book3/xhtml/chapter002" title="Link target outside of Sample">Two</span></p>
<p class="toc2k"><span href="#/Book3/xhtml/chapter003" title="Link target outside of Sample">Three</span></p>
<p class="toc2k"><span href="#/Book3/xhtml/chapter004" title="Link target outside of Sample">Four</span></p>
<p class="toc2k"><span href="#/Book3/xhtml/chapter005" title="Link target outside of Sample">Five</span></p>
<p class="toc2k"><span href="#/Book3/xhtml/chapter006" title="Link target outside of Sample">Six</span></p>
<p class="toc2k"><span href="#/Book3/xhtml/chapter007" title="Link target outside of Sample">Seven</span></p>
<p class="toc2"><span href="#/Comon/author" title="Link target outside of Sample">A Biography of Madeleine L’Engle</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bundle_content.vue?0fed10a8